import { requestJson } from "./quizApiClient";

export const getUserStats = (userId, headers = {}) => {
  if (!userId) {
    throw new Error("userId requerido");
  }
  return requestJson(`/api/users/${encodeURIComponent(userId)}/stats`, {
    method: "GET",
    headers,
  });
};

export const getUserQuizzes = (
  userId,
  { page = 1, limit = 5, status = "completed", sort = "date_desc", topicId } = {},
  headers = {}
) => {
  if (!userId) {
    throw new Error("userId requerido");
  }
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));
  if (status) params.set("status", status);
  if (sort) params.set("sort", sort);
  if (topicId) params.set("topic_id", topicId);

  return requestJson(`/api/users/${encodeURIComponent(userId)}/quizzes?${params.toString()}`, {
    method: "GET",
    headers,
  });
};

export const getUserProgress = (userId, headers = {}) => {
  if (!userId) {
    throw new Error("userId requerido");
  }

  return requestJson(`/api/users/${encodeURIComponent(userId)}/progress`, {
    method: "GET",
    headers,
  });
};
